import { render, staticRenderFns } from "./MenuItemsToFilialsField.vue?vue&type=template&id=5e72961e&scoped=true&"
import script from "./MenuItemsToFilialsField.vue?vue&type=script&lang=js&"
export * from "./MenuItemsToFilialsField.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemsToFilialsField.vue?vue&type=style&index=0&id=5e72961e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72961e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VRow,VSwitch,VTooltip})
